var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "d-flex" },
    [
      _vm.isMenu
        ? _c(
            "v-menu",
            {
              attrs: { "offset-y": "" },
              scopedSlots: _vm._u(
                [
                  {
                    key: "activator",
                    fn: function({ on }) {
                      return [
                        _c(
                          "v-btn",
                          _vm._g({ attrs: { icon: "" } }, on),
                          [_c("v-icon", [_vm._v("mdi-dots-horizontal")])],
                          1
                        )
                      ]
                    }
                  }
                ],
                null,
                false,
                2955327160
              )
            },
            [
              _vm._v(" "),
              _c(
                "v-list",
                { staticClass: "d-flex flex-row" },
                [
                  _vm.isPEM || _vm.isREE || _vm.isIEE
                    ? _c("custom-form-btn-dialog", {
                        attrs: {
                          "i18n-path": "actionplans",
                          "has-tooltip": false,
                          "has-label": _vm.hasLabel,
                          "modal-props": {
                            componentName: "ActionplanFormDialog",
                            componentProps: {
                              multiPropertyIsForbidden: true,
                              oldItem: _vm.actionPlan
                            }
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.alert.m2m_remotemanagement_enabled === "O"
                    ? _c("link-to-cofely-vision", {
                        attrs: {
                          numins: _vm.alert.property_id,
                          "has-label": _vm.hasLabel,
                          "has-sensors": "",
                          region: _vm.alert.agency_region
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "d-flex flex-row" },
            [
              _vm.isPEM || _vm.isREE || _vm.isIEE
                ? _c("custom-form-btn-dialog", {
                    attrs: {
                      "i18n-path": "actionplans",
                      "has-tooltip": false,
                      "has-label": _vm.hasLabel,
                      "modal-props": {
                        componentName: "ActionplanFormDialog",
                        componentProps: {
                          multiPropertyIsForbidden: true,
                          oldItem: _vm.actionPlan
                        }
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.alert.m2m_remotemanagement_enabled === "O"
                ? _c("link-to-cofely-vision", {
                    attrs: {
                      numins: _vm.alert.property_id,
                      "has-label": _vm.hasLabel,
                      "has-sensors": "",
                      region: _vm.alert.agency_region
                    }
                  })
                : _vm._e()
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }